import { CellContext } from "@tanstack/react-table";
import React from "react";

type Props = CellContext<any, unknown>;

const NACell: React.FC<Props> = (props) => {
  const { getValue } = props;
  const value = getValue();

  if (value == null || value === "") {
    return <>N/A</>;
  }

  if (typeof value === "number") {
    return <>{new Intl.NumberFormat("en-IN").format(value)}</>;
  }

  return <>{String(value)}</>;
};

export default NACell;
